import { type ProtocolDefinitionDetailDto, useProtocolDefinitionDetail } from "@repo/data-store";
import { createFileRoute } from "@tanstack/react-router";
import { CatalogDefinition, ProtocolDefinitionRead } from "@/features/catalog";
import { useDefinitionChangePoints, useDefinitionView } from "@/features/catalog/hooks/use-definition-as-of";
import { asOfSearchSchema } from "@/features/catalog/lib/as-of-search";
import { protocolDefinitionUrlFromRouteId } from "@/features/catalog/lib/protocol-definition-route";

export const Route = createFileRoute("/catalog/protocols/$protocolId")({
  component: ProtocolDetail,
  validateSearch: asOfSearchSchema,
});

function ProtocolDetail() {
  const { protocolId } = Route.useParams();
  const { asOf } = Route.useSearch();
  const { permissions } = Route.useRouteContext();
  const definitionUrl = protocolDefinitionUrlFromRouteId(protocolId);
  const live = useProtocolDefinitionDetail(asOf ? undefined : definitionUrl);
  const view = useDefinitionView<ProtocolDefinitionDetailDto>(definitionUrl, asOf, live);
  const { changePoints } = useDefinitionChangePoints(definitionUrl);

  if (view.isPending) return <CatalogDefinition.Pending />;
  if (!view.definition) {
    return <CatalogDefinition.NotFound label="Protocol" backTo="/catalog/procedures" backLabel="Back to procedures" />;
  }

  return (
    <ProtocolDefinitionRead
      key={`${protocolId}|${asOf ?? "latest"}`}
      definition={view.definition}
      protocolId={protocolId}
      asOf={asOf}
      changePoints={changePoints}
      canEdit={!view.isPast && permissions.canWrite("PlanDefinition")}
    />
  );
}
